// TODO: Move to @btime/helpers

import { assoc, assocPath, curry, dissoc, dissocPath } from 'ramda'

export const assocOrDissoc = curry((condition, key, value, obj) => {
  return !!condition ? assoc(key, value, obj) : dissoc(key, obj)
})

export const assocOrDissocPath = curry((condition, key, value, obj) => {
  return !!condition ? assocPath(key, value, obj) : dissocPath(key, obj)
})

export const assocOrDissocValue = curry((key, value, obj) => {
  return !!value ? assoc(key, value, obj) : dissoc(key, obj)
})
